<template>
  <td class="row settings">
      <div class="col-xs-12 col-sm-3 col-lg-2" style="padding-left:0">
          <div class="text clickable">
              <a v-if="item.repo" :href="'https://github.com/'+item.owner+'/'+item.repo" target="space">
                  <i class="octicon" :class="item.fork ? 'octicon-repo-forked':'octicon-repo'"></i> &nbsp; {{ item.owner }} / {{ item.repo }}
              </a>
          </div>
      </div>

      <div class="col-xs-12 col-sm-3 col-lg-2">
          <div>
              <span>
                  <a v-if="item.repo" :href="getSignURL" target="space">{{getGistName}}</a>
                  <div v-if="!item.repo">{{getGistName}}</div>
              </span>
              <span v-if="!item.gist">Disabled</span>
          </div>
      </div>

      <div class="col-xs-12 col-lg-2 hidden-xs hidden-sm hidden-md text">
          <a v-if="item.gist" :href="gist.html_url" target="space">{{gist.html_url}}</a>
      </div>

      <div class="col-xs-12 col-sm-2 col-lg-2 text">
          <span v-if="item.gist">{{gist.updated_at | dateFilter}}</span>
      </div>

      <div class="col-xs-12 col-sm-1 col-lg-1 text">
          <span v-if="item.gist">{{ item.sharedGist ? 'Yes' : 'No' }}</span>
      </div>

      <div class="col-xs-4 col-sm-1 col-lg-1" style="text-align:center">
          <a v-if="item.gist" @click="getReport" class="clickable" style="text-decoration: underline;">{{signatures.length}}</a>
      </div>
      <div class="col-xs-4 col-sm-1 col-lg-1 center-block" >
        <el-popover trigger="click" placement="right">
            <div id="validateLink">
                <div v-if="item.gist">
                    <i class="fa" :class="valid.gist ? 'fa-check' : 'fa-times'" style="white-space: nowrap;display:block"> gist</i>
                    <i class="fa" :class="valid.webhook ? 'fa-check' : 'fa-times'" style="white-space: nowrap;display:block"> webhook</i>
                </div>
                <div v-if="!item.gist">
                    <i class="fa fa-check" style="white-space: nowrap;"> disabled</i>
                </div>
            </div>
            <img :src="isLinkActive? 'static/images/link_active.svg' : 'static/images/link_inactive.svg'" slot="reference">        
        </el-popover>
      </div>  
      <div class="col-xs-4 col-sm-1 action" v-show="item.repo">
          <el-popover trigger="click" placement="right">
            <div style="width:140px">
                <button class="btn btn-info" @click="download" v-if='item.gist' style="width: 100%">DownLoad</button>
                <button class="btn btn-info" @click="recheck" style="margin-top: 5px;width: 100%">Recheck PRs</button>
                <button class="btn btn-info" @click="dialogTableVisible = true" v-show="item.repo && item.gist"  style="margin-top: 5px;width: 100%">Get Badge</button>
                <button class="btn btn-info" @click="dialogEditVisible = true"  style="margin-top: 5px;width: 100%">Edit</button>
            </div>
            <i class="fa fa-ellipsis-h action-icon" slot="reference"></i>
          </el-popover>
          <i class="fa fa-trash-o action-icon" style="font-size:18px;margin-right:5px" @click="dialogRemoveVisible = true" ></i>
      </div>
      <el-dialog :visible.sync="dialogTableVisible" title="Get your badge url" center>
        <badgeModal :repo="item"></badgeModal>
      </el-dialog>
      <el-dialog :visible.sync="dialogEditVisible" :title="EditTitle" width="600px" center>
        <editLinkedItemModal :item="item" :gists="gists" :gist="gist" @close="dialogEditVisible = false"></editLinkedItemModal>
      </el-dialog>
      <el-dialog :visible.sync="dialogRemoveVisible" title="Are you sure you want to unlink?" width="540px" center>
        <confirmRemoveModal :selected="item" @close="dialogRemoveVisible= false" @refresh="refresh"></confirmRemoveModal>
      </el-dialog>
      <el-dialog :visible.sync="dialogContributorVisible" :title="ContributorTitle" width="540px" center>
        <reportModal :claItem="item" :contributors="contributors" :gistName="getGistName" :historys="gist.history"></reportModal>
      </el-dialog>
  </td> 
</template>

<script>
import {getGistAttribute, getGistContent2} from 'util/util'
import badgeModal from '../modal/badge'
import editLinkedItemModal from '../modal/editLinkedItem'
import confirmRemoveModal from '../modal/confirmRemove'
import reportModal from '../modal/report'
import {getGist, validateRepoPr, getWebhook, getSignatures} from '@/api/home'
export default {
  props: {
    item:{},
    gists:{}
  },
  data() {
    return {
      loading: true,
      dialogTableVisible:false,
      dialogEditVisible:false,
      dialogRemoveVisible:false,
      dialogContributorVisible: false,
      gist: {},
      gistIndex: 0,
      valid:{
        gist:false
      },
      contributors: [],
      signatures: [],
      popoverIsOpen: false
    }
  },
  components:{badgeModal, editLinkedItemModal, confirmRemoveModal, reportModal},
  created() {
    this.validateLinkedItem()
    this.csvHeader = ['User Name', 'Repository Owner', 'Repository Name', 'CLA Title', 'Gist URL', 'Gist Version', 'Signed At', 'Signed for Organization'];
  },
  methods: {
    popoverStart() {
      var isLinkActive = document.getElementById('isLinkActive')
      isLinkActive.popover({
        content:document.getElementById('validateLink')
      })
      var moreActions = document.getElementById('moreActions')
      moreActions.popover({
        content:document.getElementById('moreActionsHtml')
      })
    },
    validateLinkedItem() {
        var promises = []
        if (this.item.gist) {
            this.loading = true
            promises.push(this._getGist())
            promises.push(this._getWebhook())
            Promise.all(promises).then(() =>{
                getSignatures({
                    repoId: this.item.repoId,
                    gist: {
                        gist_url: this.item.gist,
                        gist_version: this.gistArgs().gist_version
                    },
                    sharedGist: this.item.sharedGist
                }).then((res) =>{
                  this.signatures = res
                  this.loading = false
                })
                
            });
        }
    },
    _getGist() {
        return getGist({
            repo: this.item.repo,
            owner: this.item.owner,
            gist: this.gistArgs()
        }).then((res) =>{
            this.gist = res;
            this.valid.gist = this.gist && this.gist.id ? true : false;
            this.getCustomFields(this.item, this.gistArgs().gist_version).catch((err) =>{
              this.valid.gist = false
            })
            this.gist.linked = true;
          }
        ) 
    },
    _getWebhook() {
        return getWebhook({
                repo: this.item.repo,
                owner: this.item.owner
            }).then((res) =>{
              if(res) {
                this.valid.webhook = res.active
              }
              return 
            })
    },
    gistArgs() {
        var args = {
            gist_url: this.item.gist
        };
        if (this.gist.history && this.gist.history.length > 0) {
            args.gist_version = this.gist.history[this.gistIndex].version;
        }

        return args;
    },
    getCustomFields(linkedItem, gist_version, cb) {
        return getGistContent2(linkedItem.repoId, linkedItem.orgId, linkedItem.gist, gist_version).then((gistContent) =>{
                if (gistContent.hasCustomFields) {
                    this.csvHeader = this.csvHeader.concat();
                    gistContent.customKeys.forEach((key) =>{
                        let field = gistContent.customFields[key];
                        this.csvHeader.push(field.title || key);
                    });
                    return gistContent.customKeys
                }
                return 
            },(err) =>{
                throw new Error(err)
            }
        );
    },
    download() {
      let data = {
        repoId: this.item.repoId,
        gist: this.gistArgs()
      }
      let a = document.createElement("a");
      a.style = "display: none";
      a.href = `/exportAll?repoId=${data.repoId}&gist_url=${data.gist.gist_url}&gist_version=${data.gist.gist_version}`;
      a.download = 'signatures';

      document.body.appendChild(a);
      a.click();
    },
    recheck() {
        let linkedItem = this.item
        validateRepoPr({ repo: linkedItem.repo, owner: linkedItem.owner}).then(() =>{
          this.popoverIsOpen = false
        })
    },
    getReport() {
        if (this.signatures.length > 0) {
            this.getContributors(this.gistArgs().gist_version);
        }
        this.dialogContributorVisible = true
    },
    getContributors(gist_version) {
        let customKeys;
        this.getCustomFields(this.item, gist_version).then((keys) =>{
          customKeys = keys ? keys : customKeys;
          getSignatures({
                  repoId: this.item.repoId,
                  gist: {
                      gist_url: this.item.gist,
                      gist_version: this.gistArgs().gist_version
                  },
                  sharedGist: this.item.sharedGist
            }).then((res) =>{
              this.contributors = [];
              if (res && res.length > 0) {
                  res.forEach((signature) =>{
                      var contributor = {};
                      contributor.user_name = signature.user;
                      contributor.repo_owner = signature.owner;
                      contributor.repo_name = signature.repo;
                      contributor.gist_name = this.getGistName;
                      contributor.gist_url = signature.gist_url;
                      contributor.gist_version = signature.gist_version;
                      contributor.signed_at = signature.created_at;
                      contributor.org_cla = signature.org_cla;
                      if (customKeys && signature.custom_fields) {
                          var customFields = signature.custom_fields;
                          customKeys.forEach((key) =>{
                              contributor[key] = customFields[key];
                          });
                      }
                      this.contributors.push(contributor);
                  });
              }
            })
        }).catch((err) =>{
          this.$message.error(err);
        })
    },
    refresh(type) {
      this.$emit("refresh", type)
      this.dialogRemoveVisible = false
    }
  },
  computed:{
    getGistName() {
        if (!this.item.gist) {
            return '';
        }
        return  getGistAttribute(this.gist, 'filename');
    },
    getSignURL() {
        return '/' + this.item.owner + '/' + this.item.repo
    },
    isLinkActive() {
        return (!this.loading && this.valid.gist && this.valid.webhook) || !this.item.gist;
    },
    EditTitle() {
      return `Edit ${this.item.owner}/${this.item.repo}`
    },
    ContributorTitle() {
      return `Contributors who signed ${this.getGistName}`
    }
  },
  filters: {
    dateFilter(value) {
      if (!value) return ''
      value = value.toString()
      return value.split('T')[0]
    }
  }
}

</script>
<style>
.el-dialog__header, .el-dialog__body{
    background-color: #f5f5f5;
}
</style>


// WEBPACK FOOTER //
// src/javascript/home/components/template/settings.vue